import { useMutation } from '@tanstack/react-query';
import { GET, GET_BARCORE } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';
import { useDispatch } from 'react-redux';
import { setRegisterProductData } from '../../../redux/registerProduct/action';
import { navigateTo } from '../../../utils/navigation';
import { ROUTES_PATH } from '../../../resources/routes-name';

export const useBarcodeQuery = ({ reset, getValues }) => {
  const dispatch = useDispatch();

  const { mutate, isPending } = useMutation({
    mutationFn: async (value) => {
      const response = await GET(GET_BARCORE(value));
      if (response.result.item.allowWarranty !== 'ACTIVE') {
        throw new Error('สินค้านี้ไม่เปิดให้ลงทะเบียนรับประกันสินค้า');
      }
      return response.result;
    },
    onSuccess: (result) => {
      openAlert({
        type: 'success',
        model: 'message',
        message: 'ค้นหาสินค้าสำเร็จ',
      });
      dispatch(setRegisterProductData({ ...result }));

      const isWarrantyNumberRequired = result?.item?.isWarrantyNumberRequired;
      setTimeout(() => {
        navigateTo({
          pathname: ROUTES_PATH.ROUTE_WARRANTY_SCAN_QR.PATH,
          search: `?required=${isWarrantyNumberRequired ? '1' : '0'}`,
        });
      }, 1000);
    },
    onError: (result) => {
      reset({
        ...getValues(),
        ...result,
      });
    },
  });
  return { mutate, loading: isPending };
};
